import { useCompleteFragment } from '@eluve/apollo-client';
import { graphql } from '@eluve/graphql.tada';

import { useAppointmentId } from './appointment.context';

const fragment = graphql(`
  fragment AppointmentCompletedAt on Appointments {
    __typename
    id
    completedAt
  }
`);

export const useAppointmentCompletedAt = () => {
  const id = useAppointmentId();

  const data = useCompleteFragment({
    fragment,
    key: {
      id,
    },
  });

  return data.completedAt;
};
